import api from '../services/api';

const brandApi = {
  /**
   * Get all brands (filtered by user access)
   */
  getBrands: async (params = {}) => {
    const response = await api.get('/brands', { params });
    return response.data;
  },

  /**
   * Get all active brands
   */
  getActiveBrands: async () => {
    const response = await api.get('/brands/active');
    return response.data;
  },

  /**
   * Get all ecommerce brands
   */
  getEcommerceBrands: async () => {
    const response = await api.get('/brands/ecommerce');
    return response.data;
  },

  /**
   * Get single brand by ID
   */
  getBrand: async (id) => {
    const response = await api.get(`/brands/${id}`);
    return response.data;
  },

  /**
   * Create new brand (Admin only)
   */
  createBrand: async (data) => {
    const response = await api.post('/brands', data);
    return response.data;
  },

  /**
   * Update brand (Admin only)
   */
  updateBrand: async (id, data) => {
    const response = await api.put(`/brands/${id}`, data);
    return response.data;
  },

  /**
   * Delete brand (soft delete - archive)
   */
  deleteBrand: async (id) => {
    const response = await api.delete(`/brands/${id}`);
    return response.data;
  }
};

export { brandApi };
